<div class="ui-g-12" style="min-height: 30px">
    <a class="dimension-picker" (click)="displayTable = true"
        >{{ this.buttonText }}: <strong *ngIf="this.selectedAllocationItem">{{ this.selectedAllocationItem.ReportName }}: {{ this.selectedAllocationItem.ReportLineName }}</strong></a
    >
    <button
        *ngIf="this.selectedAllocationItem"
        class="p-button-info"
        style="margin-left: 6px"
        pButton
        (click)="selectedAllocationItem = null;this.changeAllocationItemId(null)"
        icon="ui-icon-clear"
    ></button>
    <button
        *ngIf="!this.selectedAllocationItem"
        class="p-button-info"
        pButton
        (click)="displayTable = true"
        icon="ui-icon-touch-app"
    ></button>
</div>

<p-dialog
    header="All Report Lines"
    [(visible)]="displayTable"
    [style]="{width: '80%', align: 'center' }"
    appendTo="body"
    [resizable]="true"
    [maximizable]="true"
    [closeOnEscape]="true"
    (onHide)="closed()"
>
    <div class="ui-g">
        <div class="ui-g-12">
            <list-table
                [inputListNodes]="linesForTable"
                [listColumns]="tableColumns"
                [loadingListNodes]="loading"
                [(selected)]="selected"
                selectionMode="single"
            ></list-table>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-g-12">
            <button
                label="OK"
                pButton
                icon="ui-icon-check"
                (click)="okClick()"
                style="margin-right: 0.5em"
            ></button>
            <button
                label="Cancel"
                pButton
                icon="ui-icon-cancel"
                (click)="displayTable = false"
            ></button>
        </div>
    </div>
</p-dialog>
